import { AuthenticationStateContext } from "@/providers/AuthenticationProvider/AuthenticationProvider";
import { useContext } from "react";

export function useAuthenticationState() {
  const { authState, actions } = useContext(AuthenticationStateContext);

  return {
    authState,
    actions,
  };
}
